import api from "../../http";

export default class ApiAboutAboutUs {
  static async getApiAboutAboutUs(url) {
    return api.get(url)
  }
}